import { render, staticRenderFns } from "./modalList.vue?vue&type=template&id=907d141e&"
import script from "./modalList.vue?vue&type=script&lang=js&"
export * from "./modalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports